import React from "react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-gray-200 bg-primary w-full">
      <div className="flex items-center justify-between gap-2 sm:gap-0 px-4 sm:px-6 md:px-8 py-3 sm:py-3">
        {/* Left side - Copyright */}
        <div className="text-white text-[10px] sm:text-xs font-normal text-center sm:text-left">
          COPYRIGHT © {currentYear}
        </div>

        {/* Right side - Terms and Privacy Links */}
        <div className="flex items-center gap-3 sm:gap-3">
          <a
            href="/terms"
            className="text-white text-[10px] sm:text-xs font-normal hover:text-light transition-colors cursor-pointer whitespace-nowrap"
          >
            TERMS
          </a>
          <a
            href="/privacy"
            className="text-white text-[10px] sm:text-xs font-normal hover:text-light transition-colors cursor-pointer whitespace-nowrap"
          >
            PRIVACY
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
